import { type FC, useContext } from "react"

import { AppContext } from "../providers/AppProvider"
import { ModalBase } from "./ModalBase"
import UbiqButton, { UbiqButtonSize, UbiqButtonType } from "./UbiqButton"

const LEGAL_MODAL_PANEL_STYLES =
  "w-[calc(100vw-32px)] sm:w-[960px] max-w-[960px] pt-14 sm:pt-16 pb-6 h-[80vh] sm:h-[740px]"

export const ToSModal: FC<{
  isOpen: boolean
}> = ({ isOpen }) => {
  const { hideToSModal } = useContext(AppContext)

  return (
    <ModalBase
      addBgOpacity
      dialogPanelStyles={LEGAL_MODAL_PANEL_STYLES}
      onClose={hideToSModal}
      show={isOpen}
      showCloseIcon
      title={""}
    >
      <div className="flex flex-col h-full">
        <div className="iframe-container flex-1 min-h-0 w-full">
          <iframe className="h-full" src="/terms" title="Terms of Service" width="100%"></iframe>
        </div>
        <div className="flex-shrink-0 pt-4 px-4">
          <UbiqButton
            buttonType={UbiqButtonType.LIGHT}
            onClick={hideToSModal}
            size={UbiqButtonSize.MEDIUM}
            styles="mx-auto"
            title="GOT IT"
          />
        </div>
      </div>
    </ModalBase>
  )
}
